let lastToken = '';

export function logHttpie(
  endpointUrl: string,
  request: {
    headers: Record<string, string>;
    method: string;
    credentials?: RequestCredentials;
    body?: any;
  },
  logHeadersOriginal: Record<string, string>
) {
  const logHeaders = { ...logHeadersOriginal };
  if (logHeaders.Authorization) {
    if (lastToken !== logHeaders.Authorization) {
      lastToken = logHeaders.Authorization;
    }
    logHeaders.Authorization = '$LAST_AUTH_TOKEN';
  }
  // biome-ignore lint/suspicious/noConsoleLog: <explanation>
  console.log(
    `
# Run inside api-client: ${request.method} ${endpointUrl}
http ${request.method} ${endpointUrl} ${Object.entries(logHeaders)
      .map(([key, val]) => `"${key}:${val}"`)
      .join(' ')} ${
      typeof request.body !== 'undefined'
        ? typeof request.body === 'string'
          ? request.body
          : Object.entries(JSON.parse(request.body))
              .map(([key, val]) =>
                typeof val === 'string'
                  ? `${key}="${val}"`
                  : `${key}:='${JSON.stringify(val)}'`
              )
              .join(' ')
        : ''
    }
`
  );
}
